import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _excluded = ["as", "src", "background", "altText", "gatsbyImageProps", "children", "className"];
/* eslint-disable react/forbid-prop-types */

import React from 'react';
import BackgroundImage from 'gatsby-background-image';
import Img from 'gatsby-image';
import { ChildrenPropType } from '../../../services/proptypes';
import { getOldImage } from '../../../utils/gatsby';
var defaultProps = {
  as: 'div',
  src: '',
  background: false,
  altText: '',
  gatsbyImageProps: null,
  children: null,
  className: ''
};

var ImageOld = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(ImageOld, _React$PureComponent);

  function ImageOld() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = ImageOld.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        as = _this$props.as,
        src = _this$props.src,
        background = _this$props.background,
        altText = _this$props.altText,
        gatsbyImageProps = _this$props.gatsbyImageProps,
        children = _this$props.children,
        className = _this$props.className,
        extraProps = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var imageData = getOldImage(src);

    var allGatsbyImageProps = _extends({}, extraProps, gatsbyImageProps, imageData, {
      alt: altText,
      className: "legacy-gatsby-image " + className
    });

    if (background) {
      return /*#__PURE__*/React.createElement(BackgroundImage, _extends({
        Tag: as
      }, allGatsbyImageProps), children);
    }

    return /*#__PURE__*/React.createElement(Img, allGatsbyImageProps);
  };

  return ImageOld;
}(React.PureComponent);

ImageOld.defaultProps = defaultProps;
export default ImageOld;